import React from 'react';
import { Typography, Button } from 'seagull';
import { StepPage } from "../../components/StepPage";
import { useResponsive } from "../../contexts";
import { MobileSign } from "./MobileSign";
import { Intent } from "../../../infra/access-control";
import { COBStep, getStepName } from "../ClientOnboarding.utils";
import { ErrorText } from "../../../constants";
import { useCobConfig } from "../CobConfigContext";
export default function OneLastStep(props) {
  const {
    approveAgreementStatus,
    onBack,
    approveAgreement,
    dismissPreviewModal
  } = props;
  const {
    relationship,
    isPreview
  } = useCobConfig();
  const {
    isDesktop
  } = useResponsive();
  return /*#__PURE__*/React.createElement(StepPage, {
    header: getStepName(COBStep.summary, relationship),
    showLearnMore: true,
    errorTestid: "step9-error-message",
    errorMessage: ErrorText.UnexpectedErrorTryAgain,
    showError: approveAgreementStatus === 'error',
    primaryBtn: isPreview && dismissPreviewModal ? /*#__PURE__*/React.createElement(Button, {
      onClick: dismissPreviewModal,
      "data-testid": "preview-dismiss-modal"
    }, "Close preview") : isDesktop ? /*#__PURE__*/React.createElement(Button, {
      intent: Intent.ApproveProposal,
      disabled: approveAgreementStatus === 'loading' || isPreview,
      onClick: () => approveAgreement(),
      "data-testid": (relationship.isSample ? 'test-agreement-' : '') + 'step9-next-btn'
    }, relationship.isSample ? 'Approve test agreement' : 'Approve agreement') : /*#__PURE__*/React.createElement(MobileSign, {
      intent: Intent.ApproveProposal,
      relationship: relationship,
      onSign: () => approveAgreement()
    }),
    backBtnTestid: (relationship.isSample ? 'test-agreement-' : '') + 'step9-back-btn',
    testid: "one-last-step",
    onBackBtnClick: onBack
  }, /*#__PURE__*/React.createElement(Typography, null, "Digitally sign to approve the agreement."));
}